import { useEffect, useState } from "react";

export default function Countdown({ target, variant = "dark" }) {
  const [remaining, setRemaining] = useState(() => diff(target));

  useEffect(() => {
    setRemaining(diff(target));
    if (!target) return;
    const id = setInterval(() => setRemaining(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const items = [
    { l: "Días", v: remaining.days },
    { l: "Horas", v: remaining.hours },
    { l: "Min", v: remaining.minutes },
    { l: "Seg", v: remaining.seconds },
  ];

  const styles = {
    dark: { wrap: "border-white/10 bg-[#141414]", num: "text-[#FAFAFA]", lbl: "text-[#A3A3A3]" },
    light: { wrap: "border-[#0A0A0A]/12 bg-white", num: "text-[#0A0A0A]", lbl: "text-[#737373]" },
  };
  const s = styles[variant] || styles.dark;

  if (remaining.loading) {
    return (
      <div className="grid grid-cols-4 gap-2 sm:gap-3" data-testid="countdown-loading">
        {items.map((it) => (
          <div key={it.l} className={`border rounded-xl px-3 py-3 sm:px-4 sm:py-4 text-center ${s.wrap}`}>
            <div className={`font-display text-3xl sm:text-4xl tabular-nums leading-none ${s.num} opacity-40`}>--</div>
            <div className={`text-[10px] uppercase tracking-widest mt-2 font-mono font-medium ${s.lbl}`}>{it.l}</div>
          </div>
        ))}
      </div>
    );
  }

  if (remaining.done) {
    return (
      <div className={`inline-flex items-center gap-3 border rounded-full px-4 py-2 ${s.wrap}`}>
        <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" />
        <span className={`text-xs uppercase tracking-widest font-mono font-medium ${s.num}`}>Convocatoria cerrada</span>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-4 gap-2 sm:gap-3" data-testid="countdown">
      {items.map((it) => (
        <div key={it.l} className={`border rounded-xl px-3 py-3 sm:px-4 sm:py-4 text-center ${s.wrap}`}>
          <div className={`font-display text-3xl sm:text-4xl tabular-nums leading-none ${s.num}`} data-testid={`countdown-${it.l.toLowerCase()}`}>
            {String(it.v).padStart(2, "0")}
          </div>
          <div className={`text-[10px] uppercase tracking-widest mt-2 font-mono font-medium ${s.lbl}`}>{it.l}</div>
        </div>
      ))}
    </div>
  );
}

function diff(target) {
  if (!target) return { loading: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  const t = new Date(target).getTime();
  if (Number.isNaN(t)) return { loading: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  const now = Date.now();
  const ms = t - now;
  if (ms <= 0) return { done: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const seconds = Math.floor((ms / 1000) % 60);
  return { done: false, days, hours, minutes, seconds };
}
